import { createRouter, createWebHistory } from "vue-router";
import Auth from "../views/Auth.vue";
import store from "@/store/index.js";

const routes = [
	{
		path: "/",
		name: "Auth",
		component: Auth,
		meta: {
			noAuthRequired: true,
		},
	},
	{
		path: "/privacy",
		name: "Privacy Policy",
		component: () => import("../views/Privacy.vue"),
	},
	{
		path: "/reset",
		name: "ForgotPassword",
		component: () => import("../views/ForgotPassword.vue"),
		meta: {
			noAuthRequired: true,
		},
	},
	{
		path: "/account-actions/action",
		name: "AccountActions",
		component: () => import("../views/AccountActions.vue"),
		meta: {
			noAuthRequired: true,
		},
	},
	{
		path: "/user",
		name: "User",
		component: () => import("../views/User.vue"),
		meta: {
			authRequired: true,
		},
	},
	{
		path: "/user/:User_Id",
		name: "User_ID",
		component: () => import("../views/AdminUser.vue"),
		meta: {
			authRequired: true,
		},
	},
	{
		path: "/admin",
		name: "Admin",
		component: () => import("../views/Admin.vue"),
		meta: {
			adminRequired: false,
		},
	},
	{
		path: "/admin-news",
		name: "AdminManageNews",
		component: () => import("../views/AdminManageNews.vue"),
		meta: {
			adminRequired: false,
		},
	},
	{
		path: "/admin-news/:News_Id",
		name: "News_ID",
		component: () => import("../views/AdminEditNews.vue"),
		meta: {
			authRequired: true,
		},
	},
	{
		path: "/settings",
		name: "Settings",
		component: () => import("../views/Settings.vue"),
		meta: {
			authRequired: true,
		},
		children: [
			{
				path: 'update-profile',
				component: () => import("../components/UpdateFormNew.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: 'update-tickets',
				component: () => import("../components/UpdateFormTickets.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: 'update-tickets-test',
				component: () => import("../components/UpdateFormTicketsTestBootstrapNov16.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: 'test',
				component: () => import("../components/UpdateFormTicketsTestBootstrap.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: 'update-test',
				component: () => import("../components/UpdateTest.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: 'opt-out',
				component: () => import("../views/OptOut.vue"),
				props: true,
				meta: {
					authRequired: true,
				}
			}
		]
	},
	{
		path: "/enroll-now",
		name: "EnrollNow",
		component: () => import("../views/EnrollNow.vue"),
		meta: {
			authRequired: true,
		},
	},
	{
		path: "/change-password",
		name: "ChangePassword",
		component: () => import("../views/ChangePassword.vue"),
		meta: {
			authRequired: true,
		},
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("../views/NotFound.vue"),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.authRequired)) {
		if (store.state.user.loggedIn === true) {
			next();
		} else {
			alert("You Must be logged in");
			next({
				path: "/",
			});
		}
	} else {
		next();
	}
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.noAuthRequired)) {
		if (store.state.user.loggedIn === false) {
			next();
		} else {
			next({
				path: "/user",
			});
		}
	} else {
		next();
	}
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.adminRequired)) {
		if (store.state.user.apiData.isStrideAdmin === true) {
			next();
		} else {
			next({
				path: "/user",
			});
		}
	} else {
		next();
	}
});

export default router;
